import { HTTP_METHODS } from 'config';

import { request } from '@quintoandar/wat-fetch';
import { addBreadcrumb } from '@quintoandar/fwp-error-monitoring';
import { hasAuthCookie } from '@quintoandar/wat-cookie';
import { getCookie } from '@quintoandar/fwp-cookie';
/**
 * Basic configuration for agents api calls
 *
 * @param {string} endpoint - The endpoint that will be called
 * @param {object} [filters] - The filters object for the current screen
 * @param {string} method - The HTTP method that will be used
 * @param {object} [payload] - The data
 * @param {string} [tab] - Current active tab
 *
 * @returns {Promise}
 */
export const mobileRoApiConfig = async ({
  endpoint,
  method,
  payload,
  queryString,
  extraHeaders,
}) => {
  const authCookie = getAuthCookieValues();
  let config;
  let options;
  try {
    switch (method) {
      default:
      case HTTP_METHODS.GET:
        options = {
          method,
          headers: extraHeaders,
          body: payload ? JSON.stringify(payload) : undefined,
        };
        if (queryString) {
          config = await request(
            `${process.env.MOBILE_API_URL_RO}/${endpoint}?${queryString}`,
            options,
          );
        } else {
          config = await request(
            `${process.env.MOBILE_API_URL_RO}/${endpoint}`,
            options,
          );
        }
        break;
    }
    addBreadcrumb({
      message: 'Request to api success',
      data: {
        endpoint,
        method,
        payload,
        queryString,
        extraHeaders,
        response: config,
        hasAuthCookie: authCookie.hasAuthCookie,
        authCookieStatus: authCookie.valueStatus,
        authCookieLength: authCookie.valueLength,
      },
    });
    return config;
  } catch (error) {
    addBreadcrumb({
      message: 'Request to api error',
      data: {
        endpoint,
        method,
        payload,
        queryString,
        extraHeaders,
        error,
        hasAuthCookie: authCookie.hasAuthCookie,
        authCookieStatus: authCookie.valueStatus,
        authCookieLength: authCookie.valueLength,
      },
    });
    throw error;
  }
};

export default mobileRoApiConfig;

function getAuthCookieValues() {
  try {
    return {
      hasAuthCookie: hasAuthCookie(),
      valueStatus: getAuthCookieStatus(),
      valueLength: getCookie('5AJWT_AUTH')?.length,
    };
  } catch (error) {
    return {
      hasAuthCookie: false,
      valueStatus: 'error',
      valueLength: 0,
    };
  }
}
function getAuthCookieStatus() {
  const value = getCookie('5AJWT_AUTH');
  if (value === undefined) return 'undefined';
  if (value === null) return 'null';
  return value.length > 0 ? 'present' : 'empty';
}
